import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { environment } from "./environments/environment";
import * as Sentry from "@sentry/react";
import { store } from "./reducers/store";
import { Provider } from "react-redux";

// Initialize Sentry
Sentry.init({
  dsn: "https://588156e3eae66e3e25e9ecf742b408ba@o4508002545303552.ingest.us.sentry.io/4508461301563392",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0, // Adjust this value in production for performance monitoring
  tracePropagationTargets: [
    "localhost",
    "/^https://enspire-qnet.qlever.io/rest",
    "/^https://qnet-staging.teamqualityservices.com/rest",
    "/^https://qnet.teamqualityservices.com/rest",
  ],
  //capture replay for 10% of all sessions,
  //plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: environment.production ? "production" : "development",
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    {!environment.strictMode ? (
      <App />
    ) : (
      <React.StrictMode>
        <App />
      </React.StrictMode>
    )}
  </Provider>,
);
